<template>
    <div class="system">
        <img src="../assets/system.png"/>
        <p>系统维护中</p>
    </div>
</template>

<script>
    export default {
        name: "System"
    }
</script>

<style lang="scss" scoped>

    body {

    }

    .system {
        width: 100%;
        height: 100%;
        background: #2d8cf0;
        position: fixed;
        img {
            width: 15rem;
            margin-top: 10rem;
        }

        p {
            font-size: 1.5rem;
            margin: 40px;
            color: #FFFFFF;
        }

    }
</style>